import axios from 'axios';

export const postData = async (
    bodyToSend,
    path,
    contentTyoe = 'application/json'
) => {
    const data = JSON.stringify(bodyToSend);
    const config = {
        method: 'post',
        url: `${path}`,
        timeout: 5000,
        headers: {
            'Content-Type': 'application/json',
        },
        data: data,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const getData = async (path: string) => {
    const config = {
        method: 'get',
        url: path.includes('http') ? path : path,
        timeout: 5000,
        headers: {
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const getDataSecure = async (path, token) => {
    const config = {
        method: 'get',
        url: path,
        timeout: 5000,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const postDataSecure = async (
    bodyToSend,
    path,
    token,
    contentType = 'application/json'
) => {
    const data = JSON.stringify(bodyToSend);
    const config = {
        method: 'post',
        url: `${path}`,
        timeout: 5000,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': contentType,
        },
        data: data,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
};

/**
 * setTimeout method that can be used in asynchronous methods
 */
export function asyncTimeout(timeoutPeriod: number) {
    return new Promise((resolve) => setTimeout(resolve, timeoutPeriod));
}

export function isValidHttpUrl(string: string) {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
}
